import React from 'react'
import { BoxPreview } from '../BoxEmail/styled'
import { Container } from './styled'

import imgBackground from "../../../../assets/imgs/preview-background.png";
import PdfPreviewWatermark from './PdfPreviewWatermark';

const BoxWatermart = () => {
    return (
        <Container>
            <BoxPreview img={imgBackground} style={{ position: "relative" }}>
                <PdfPreviewWatermark />
            </BoxPreview>
        </Container>
    )
}

export default BoxWatermart
